import React, { useState } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import TextArea from 'b2b-ui-components-lib/lib/components/textarea';
import { getDefaultValue } from './formControl';

import './index.scss';

const ShippingDetailsSummary = ({ orderDetail }) => {
  const [form, setForm] = useState(getDefaultValue(orderDetail));

  return (
    <div className="shipping_details form_area">
      <h6>Shipping Details</h6>
      <Checkbox checked={form.selected} onChange={() => {}} disabled>
        <span className="check_text">Shipping details same as billing details</span>
      </Checkbox>
      <div className="row field_row">
        <div className="flg-lg-12 flg-md-12">
          <div className="row">
            <div className="flg-lg-6 flg-md-6">
              <Input label="Shipping Address Pin Code" maxlength={6} value={form.pinCode.value ? form.pinCode.value : ''} required touched disabled />
            </div>
            <div className="flg-lg-6 flg-md-6">
              <Input label="Shipping Address City" value={form.city.value} placeholder="City" required disabled />
            </div>
          </div>
          <div className="row">
            <div className="flg-lg-12">
              <TextArea label="Shipping Address" maxlength={250} required value={form.address.value} touched disabled />
            </div>
            <div style={{ position: 'relative' }}>
              <small id="helpId" className="help-text-counter">
                {(form.address.value && form.address.value.length) || 0} /250
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingDetailsSummary;
